module.exports = __webpack_public_path__ + "img/infoLopBg.56bafbab.png";